export default {
  navHome: "ホーム",
  navProducts: "製品",
  navCases: "応用事例",
  navAbout: "会社概要",
  deliverTo: "配送先:",
  langCurrencyLabel: "日本語",
  localeLangTitle: "言語設定",
  localeLangDesc: "ご希望の言語を選択してください。いつでもこの設定を変更できます。",
  language: "言語",
  save: "保存",
  coreProducts: "現実世界の創造を支援します。",
  coreProductsDesc: "アイデアからビジネスへ — YONGYUANはUVプリンター、クリスタルラベルプリンター、高速円筒プリンター、DTFおよびDTGプリンターを提供し、創造性を製品、ブランド、機会に変えます。",
  scenariosTitle: "あらゆるシーンに対応するソリューション",
  scenariosDesc: "ブランド構築、副業の開発、創造的な情熱の追求 — YONGYUANはお客様のニーズに合わせたソリューションを提供します。",
  scenarioStudio: "スタジオ",
  scenarioStudioDesc: "高付加価値カスタマイズ、小ロット試作、ブランド構築",
  scenarioRetail: "ブランド小売",
  scenarioRetailDesc: "顧客滞在時間の延長と店舗売上の向上",
  scenarioMarket: "ポップアップマーケット",
  scenarioMarketDesc: "現場カスタマイズ、完成品販売、副収入",
  scenarioEnterprise: "企業向けカスタマイズ",
  scenarioEnterpriseDesc: "バッチカスタマイズ、ブランドグッズ、企業ギフト",
  scenarioEcommerce: "ライブコマース",
  scenarioEcommerceDesc: "ヒット商品のサンプリング、柔軟な供給、迅速な新商品投入",
  scenarioStore: "ECストア",
  scenarioStoreDesc: "ストアカスタマイズ、ヒット商品、差別化された運営",
  scenarioFactory: "工場生産",
  scenarioFactoryDesc: "量産、安定した出力、コスト効率の高い運営",
  scenarioAdvertising: "広告制作",
  scenarioAdvertisingDesc: "看板、ディスプレイ素材、イベント資料",
  industries: "業界応用",
  industriesDesc: "様々な業界のカラー印刷ニーズに対応するデジタルインクジェット印刷ソリューション。",
  applicationsTitle: "日常および商業ニーズに対応する多様な素材と色彩の応用。",
  applicationsDesc: "YONGYUAN UV印刷機器は幅広い素材とプロセスシーンに対応し、パーソナライズカスタマイズと大規模生産を支援します。",
  casesHeroDesc: "1200以上の業界応用と数万種類の印刷可能素材に対応し、さまざまなビジネス向けのデジタル印刷ソリューションを提供します。",
  casesBreadcrumbHome: "ホーム",
  casesBreadcrumbCenter: "応用事例",
  casesEmpty: "このカテゴリの応用事例はまだありません。",
  customerStoriesTitle: "世界中のお客様から信頼されています",
  customerStoriesSubtitle: "172カ国における、実際の設置、実際のお客様、実際の印刷ビジネス。",
  customerStoriesStat1Value: "53,000+",
  customerStoriesStat1Label: "納入台数",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "サービス国",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "業界経験",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "テクニカルサポート",
  customerStoriesPlaceholder: "お客様写真を追加",
  customerStoriesPhotoAlt: "YONGYUANお客様とプリンター",
  servicePartnerTitle: "YONGYUANサービスチームをご紹介 — あなたのクリエイティブパートナー",
  servicePartnerDesc: "機器の性能とビジネス成長を守るグローバルサービスネットワークと専門サポート体制。",
  serviceSupportTitle: "標準サポート",
  serviceSupportDesc: "設置ガイダンス、基礎トレーニング、日常使用サポートで機器の安定稼働を保証。",
  servicePresaleTitle: "販売前デモ＆コンサルティング",
  servicePresaleDesc: "応用シーンと生産能力の要件に合わせたソリューションデモと機種推奨。",
  serviceLifetimeTitle: "生涯技術サポート",
  serviceLifetimeDesc: "長期的なビジネス発展を支える継続的な技術対応とプロセスサポート。",
  serviceCareTitle: "YONGYUAN Careにアップグレード",
  serviceCareDamageTitle: "偶発的損害保護",
  serviceCareDamageDesc: "予期しない事故による損失を軽減するためのより包括的な保護プラン。",
  serviceCareExchangeTitle: "迅速交換サービス",
  serviceCareExchangeDesc: "条件を満たす場合の優先迅速交換で資本回収を加速。",
  viewProduct: "製品を見る",
  learnMore: "詳しく見る",
  catUv: "UVフラットベッドプリンター",
  catCylinder: "円筒体プリンター",
  catCrystal: "クリスタルラベルプリンター",
  catDtf: "DTFプリンター",
  catDtg: "DTGプリンター",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "電話: 17748697567 タン・マネージャー",
  email: "メール: sales@yongyuanprinter.com",
  copyright: "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. All rights reserved",
  productsHeroTitle: "製品",
  productsHeroDesc: "多様な生産能力と応用ニーズに対応するUVフラットベッド、円筒、クリスタルラベル、DTF、DTG機器のフルラインナップ。",
  productsBreadcrumbHome: "ホーム",
  productsBreadcrumbCenter: "製品",
  productsEmpty: "このカテゴリの製品は近日公開予定です。",
  productsQuoteTitle: "ソリューション＆見積もり依頼",
  productsQuoteDesc: "応用シーンと生産能力の要件をお知らせください。最適な機器ソリューションをご提案します。",
  productsContact: "お問い合わせ",
  aboutHeroTitle: "Yongyuanについて",
  aboutHeroDesc: "UV印刷機器の研究開発・生産に17年専念",
  productA23Subtitle: "デスクトップ6色インテリジェントUVプリンター",
  productA23Feature1: "A4印刷フォーマット",
  productA23Feature2: "インテリジェントインク供給システム",
  productA23Feature3: "赤外線自動高さ検出",
  productA35Subtitle: "デスクトップ6色インテリジェントUVプリンター",
  productA35Feature1: "A3+印刷フォーマット",
  productA35Feature2: "インテリジェントインク供給システム",
  productA35Feature3: "赤外線自動高さ検出",
  productA43Subtitle: "フラッグシップ8色インテリジェントUVプリンター",
  productA43Feature1: "A3印刷フォーマット",
  productA43Feature2: "複数プリントヘッド構成",
  productA43Feature3: "インテリジェントインク供給システム",
  productA46Subtitle: "フラッグシップ8色インテリジェントUVプリンター",
  productA46Feature1: "A2印刷フォーマット",
  productA46Feature2: "複数プリントヘッド構成",
  productA46Feature3: "インテリジェントインク供給システム",
  productA57Subtitle: "フラッグシップ8色インテリジェントUVプリンター",
  productA57Feature1: "A2+印刷フォーマット",
  productA57Feature2: "複数プリントヘッド構成",
  productA57Feature3: "インテリジェントインク供給システム",
  productA69Subtitle: "フラッグシップ8色インテリジェントUVプリンター",
  productA69Feature1: "A1印刷フォーマット",
  productA69Feature2: "複数プリントヘッド構成",
  productA69Feature3: "インテリジェントインク供給システム",
  productA1216Subtitle: "フラッグシップ大型UVフラットベッドプリンター",
  productA1216Feature1: "1200×1600cm印刷フォーマット",
  productA1216Feature2: "複数プリントヘッド構成",
  productA1216Feature3: "ビジョン位置決めシステム",
  productA2513Subtitle: "フラッグシップ大型UVフラットベッドプリンター",
  productA2513Feature1: "2500×1300cm印刷フォーマット",
  productA2513Feature2: "複数プリントヘッド構成",
  productA2513Feature3: "ビジョン位置決めシステム",
  productCylinderElfSubtitle: "360°高速円筒プリンター",
  productCylinderElfFeature1: "360°印刷",
  productCylinderElfFeature2: "カップ＆ボトルカスタマイズ",
  productCylinderElfFeature3: "迅速治具交換",
  productCupPlusSubtitle: "多サイズカップ＆ボトル印刷ソリューション",
  productCupPlusFeature1: "多サイズ治具",
  productCupPlusFeature2: "高い生産効率",
  productCupPlusFeature3: "安定した出力",
  productCrystal60Subtitle: "クリスタルラベル印刷＆ホイル一体型システム",
  productCrystal60Feature1: "60cm幅",
  productCrystal60Feature2: "印刷＆ホイル統合",
  productCrystal60Feature3: "効率的な巻取りシステム",
  productCrystalC60UltraFeature1: "60cm幅",
  productCrystalC60UltraFeature2: "燙金/燙銀/3Dシリコンラベル多方案",
  productCrystalC60UltraFeature3: "大量生産",
  productCrystal30Subtitle: "コンパクト高精度クリスタルラベルプリンター",
  productCrystal30Feature1: "コンパクト精密印刷",
  productCrystal30Feature2: "簡単操作",
  productCrystal30Feature3: "パーソナライズカスタマイズ",
  productDtf60Subtitle: "ホワイトインクDTF転写プリンター",
  productDtf60Feature1: "ホワイトインクDTF転写",
  productDtf60Feature2: "豊かな色彩レイヤー",
  productDtf60Feature3: "衣料アクセサリー",
  productDtfF20Subtitle: "業界最小のデスクトップ白墨DTFプリンター",
  productDtfF20Feature1: "A4サイズ",
  productDtfF20Feature2: "小ロットカスタマイズ",
  productDtfF20Feature3: "スマートインクシステム",
  productDtfF30Subtitle: "デスクトップ白墨DTFプリンター",
  productDtfF30Feature1: "A3サイズ",
  productDtfF30Feature2: "シングルヘッド手動/自動版選択可能",
  productDtfF30Feature3: "スマートインクシステム",
  productDtfF30ProSubtitle: "白墨DTFプリンター",
  productDtfF30ProFeature1: "A3サイズ",
  productDtfF30ProFeature2: "デュアルヘッド自動フィルム巻取",
  productDtfF30ProFeature3: "スマートインクシステム",
  productDtfF33Subtitle: "白墨DTFプリンター",
  productDtfF33Feature1: "A3サイズ",
  productDtfF33Feature2: "シングルヘッド手動/自動版選択可能",
  productDtfF33Feature3: "スマートインクシステム",
  productDtfF70ProSubtitle: "70cm幅白墨DTFプリンター",
  productDtfF70ProFeature1: "A2サイズ",
  productDtfF70ProFeature2: "2～4ヘッド構成選択可能",
  productDtfF70ProFeature3: "自動給排料システム",
  productDtfF70ProFeature4: "スマート中断再開印刷モード",
  productDtf30Subtitle: "コンパクトホワイトインクDTFプリンター",
  productDtf30Feature1: "小ロットカスタマイズ",
  productDtf30Feature2: "正確な色彩再現",
  productDtf30Feature3: "使いやすい",
  productDtgPrintSubtitle: "デジタルダイレクト・トゥ・ガーメントプリンター",
  productDtgPrintFeature1: "多素材ダイレクト印刷",
  productDtgPrintFeature2: "高スループット",
  productDtgPrintFeature3: "安定＆耐久性",
  productDtg3250DSubtitle: "業界唯一のDTF&DTG一体型モデル",
  productDtg3250DFeature1: "A3+幅",
  productDtg3250DFeature2: "DTF&DTGデュアル工程印刷",
  productDtg3250DFeature3: "スマートインクシステム",
  productDtg3646TSubtitle: "デュアルステーションDTGプリンター",
  productDtg3646TFeature1: "連続生産モード",
  productDtg3646TFeature2: "生産効率100%向上",
  productDtg3646TFeature3: "スマートインクシステム",
  productDtgMaxSubtitle: "産業用デジタルDTGプリンター",
  productDtgMaxFeature1: "産業用生産能力",
  productDtgMaxFeature2: "安定＆耐久性",
  productDtgMaxFeature3: "連続稼働",
  app01Title: "スマホケース",
  app02Title: "ゴルフボール",
  app03Title: "石板画",
  app04Title: "ボールペン",
  app05Title: "メガネケース",
  app06Title: "木版画",
  app07Title: "飲料缶",
  app08Title: "キーボード",
  app09Title: "タンブラー",
  app10Title: "スーツケース",
  app11Title: "アクリル製品",
  app12Title: "ノートブック",
  app13Title: "バッジ",
  app14Title: "レザーカードホルダー",
  app15Title: "ドッグタグ",
  app16Title: "ガラスアート",
  appDtgCase01: "Tシャツ",
  appDtgCase02: "パーカー",
  regionCn: "中国",
  regionUs: "アメリカ",
  regionGb: "イギリス",
  regionDe: "ドイツ",
  regionAe: "UAE",
  regionIn: "インド",
  regionJp: "日本",
  regionVn: "ベトナム",
  regionBr: "ブラジル",
  regionAu: "オーストラリア",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
